
import { defineComponent, onMounted, reactive, ref, toRefs } from 'vue'
import { formatDate, formatThousands } from '@/utils'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { getAcceptanceBillTransfers, getProcessedDetails } from '@/apis/accepted-bill/acceptanceReceipt'
import {
  formatBanendFlag, formatBehaveType, formatDraftType, formatRequestEntrustPay, formatSignupMark, formatSplitFlag
} from '@/utils/acceptanceBillFormatUtil'
import Container from '@/components/form/container/Container.vue'
import { ElMessage } from 'element-plus'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import {
  AcceptanceBillDetailModel, AcceptanceBillTransfersParamModel,
  ReceiptAcceptedBillTransferRecordModel
} from '@/model/accepted-bill/acceptedBillModel'

export default defineComponent({
  name: 'AcceptanceHistoryDetail',
  methods: { formatThousands },
  components: {
    SimpleTable,
    Container
  },
  setup() {
    const { t } = useI18n()
    const tableRef = ref()
    const id = useRoute().params.id.toString()
    const statusMap = {
      0: t('acceptanceStatus.pendingConfirmation'),
      1: t('acceptanceStatus.underReview'),
      2: t('acceptanceStatus.pendingAction'),
      3: t('acceptanceStatus.operated'),
      98: t('acceptanceStatus.received'),
      99: t('acceptanceStatus.rejected')
    }
    const detailTableStruct = [
      { prop: 'behaveNo', label: t('Acceptance.behaveNo') },
      { prop: 'behaveType', label: t('Acceptance.behaveType'), formatter: (row: ReceiptAcceptedBillTransferRecordModel) => formatBehaveType(row.behaveType) },
      { prop: 'behaveDate', label: t('Acceptance.behaveDate'), formatter: (row: ReceiptAcceptedBillTransferRecordModel) => formatDate(row.behaveDate, 'yyyy-MM-dd') },
      { prop: 'requestObject', label: t('Acceptance.requestObject') },
      { prop: 'requestBankName', label: t('Acceptance.requestBankName') },
      { prop: 'responseObject', label: t('Acceptance.responseObject') },
      { prop: 'responseBankName', label: t('Acceptance.responseBankName') },
      { prop: 'banendFlag', label: t('Acceptance.banendFlagTrue'), formatter: (row: ReceiptAcceptedBillTransferRecordModel) => formatBanendFlag(row.banendFlag) },
      { prop: 'signupMark', label: t('Acceptance.signupMark'), formatter: (row: ReceiptAcceptedBillTransferRecordModel) => formatSignupMark(row.signupMark) }
    ]
    const dataMap = reactive({
      tableData: Array<ReceiptAcceptedBillTransferRecordModel>(),
      columnStruct: detailTableStruct,
      listLoading: true,
      detailData: {} as AcceptanceBillDetailModel | null,
      status: null as string | null,
      async getData() {
        dataMap.listLoading = true

        let acceptanceId
        try {
          acceptanceId = Number(id)
        } catch (error) {
          ElMessage({
            message: 'id 格式错误;' + id,
            type: 'error',
            duration: 2000
          })
          return
        }
        const data = await getProcessedDetails(acceptanceId)
        if (data && data.data) {
          dataMap.detailData = data.data
          dataMap.tableData = data.data.transferRecords
          dataMap.status = statusMap[data.data.status]
          if (!dataMap.tableData || dataMap.tableData.length === 0) {
            const params: AcceptanceBillTransfersParamModel = {
              companyCode: dataMap.detailData.companyCode,
              companyBankId: dataMap.detailData.companyBank,
              status: dataMap.detailData.status,
              draftNo: dataMap.detailData.draftNo,
              draftRange: dataMap.detailData.draftRange,
              draftType: dataMap.detailData.draftType
            }
            const transferData = await getAcceptanceBillTransfers(params)
            if (transferData && transferData.data) {
              dataMap.tableData = transferData.data
            } else {
              ElMessage({
                message: transferData?.msg,
                type: 'error',
                duration: 2000
              })
            }
          }
        } else {
          dataMap.detailData = null
          ElMessage({
            message: data?.msg,
            type: 'error',
            duration: 2000
          })
        }

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      }
    })
    onMounted(() => {
      dataMap.getData()
    })
    return {
      t,
      tableRef,
      formatBanendFlag,
      formatSplitFlag,
      formatRequestEntrustPay,
      formatDraftType,
      ...toRefs(dataMap)
    }
  }
})
